(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bottom-nav"] && !Shopify.designMode) return;
  try {
    // Reads localStorage favourites count and toggles the indicator badge.
  function updateFavouritesBadge() {
    const badges = document.querySelectorAll('[data-favourites-count]');
    if (badges.length === 0) return;

    if (!window.Favourites) {
      // Favourites module not loaded yet, retry in a moment
      setTimeout(updateFavouritesBadge, 100);
      return;
    }

    const count = window.Favourites.count();
    badges.forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  }

  // Reads cross-domain CTA count cookie and toggles the indicator badge.
  function updateCTABadge() {
    const badges = document.querySelectorAll('[data-cta-count]');
    if (badges.length === 0) return;

    const match = document.cookie.match(/(?:^|;\s*)ls_cta_count=(\d+)/);
    const count = match ? parseInt(match[1], 10) : 0;

    badges.forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  }

  // Initial update
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateFavouritesBadge();
      updateCTABadge();
    });
  } else {
    updateFavouritesBadge();
    updateCTABadge();
  }

  // Update on changes
  document.addEventListener('favourites:change', updateFavouritesBadge);

  // Restore last shop URL from cookie
  const shopLink = document.querySelector('[data-shop-nav-link]');
  if (shopLink) {
    shopLink.addEventListener('click', function(e) {
      const match = document.cookie.match(/(?:^|;\s*)ls_return_url=([^;]*)/);
      const returnUrl = match ? decodeURIComponent(match[1]) : null;
      const currentUrl = window.location.pathname + window.location.search;

      if (returnUrl && returnUrl !== currentUrl) {
        e.preventDefault();
        window.location.assign(returnUrl);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const toggle = document.getElementById('cart-drawer-toggle');
    const cartRoots = document.querySelectorAll('[data-cart-ui]');
    if (!toggle || cartRoots.length === 0) return;

    const i18nEl = document.querySelector('[data-cart-drawer-i18n]');
    const i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {};
    const cartChangeToast = document.getElementById('cart-change-toast');
    const toastPanels = {
      success: cartChangeToast?.querySelector('[data-cart-toast-success]'),
      already_in_bag: cartChangeToast?.querySelector('[data-cart-toast-already-in-bag]'),
      error: cartChangeToast?.querySelector('[data-cart-toast-error]'),
    };
    const toastErrorMessage = cartChangeToast?.querySelector('[data-cart-toast-error-message]');
    let cartToastTimeout;
    let cartOperationQueue = Promise.resolve();
    let isCartOperation = false;

    const moneyFormat = cartRoots[0].dataset.moneyFormat || '${{amount}}';
    const currency = cartRoots[0].dataset.currency || 'GBP';

    function getRootEls(root) {
      return {
        count: root.querySelector('[data-cart-count]'),
        empty: root.querySelector('[data-cart-empty]'),
        body: root.querySelector('[data-cart-body]'),
        items: root.querySelector('[data-cart-items]'),
        footer: root.querySelector('[data-cart-footer]'),
        stickyCheckout: root.querySelector('[data-cart-sticky-checkout]'),
        checkouts: root.querySelectorAll('[data-cart-checkout]'),
      };
    }

    function formatMoney(cents) {
      const value = Number(cents);
      if (!Number.isFinite(value)) return '';

      let formatted;
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        formatted = Shopify.formatMoney(value, moneyFormat);
      } else {
        const amount = (value / 100).toFixed(2);
        formatted = moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value / 100));
      }
      return formatted.replace(/<[^>]*>/g, '');
    }

    function itemCountLabel(count) {
      const template = count === 1 ? i18n.itemCountOne : i18n.itemCount;
      if (!template) return count === 1 ? `${count} item` : `${count} items`;
      return template.replace('__COUNT__', count);
    }

    function quantityLabel(count) {
      const template = i18n.quantity || 'Qty: __COUNT__';
      return template.replace('__COUNT__', count);
    }

    function checkoutLabel(totalFormatted) {
      if (!totalFormatted) return i18n.checkout || 'Checkout';
      const template = i18n.checkoutWithTotal || 'Checkout · __TOTAL__';
      return template.replace('__TOTAL__', totalFormatted);
    }

    function renderItem(item) {
      const onSale = item.original_line_price !== item.final_line_price;
      const imageHtml = item.image
        ? `<a href="${item.url}" class="block h-20 w-20 shrink-0 overflow-hidden rounded-xl border border-white/70 bg-white/80 shadow-float" tabindex="-1">
             <img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" class="block h-full w-full object-cover" loading="lazy" width="80" height="80">
           </a>`
        : '';

      return `
        <li class="basket-drawer__item transition-all duration-300" data-cart-line-key="${item.key}">
          <article class="flex items-start gap-3 p-3">
            ${imageHtml}
            <div class="min-w-0 flex-1">
              <p class="m-0 text-[10px] font-bold uppercase tracking-[0.12em] text-base-content/40">${item.vendor || ''}</p>
              <a href="${item.url}" class="mt-0.5 block text-sm font-semibold no-underline hover:text-primary">${item.product_title}</a>
              <p class="m-0 mt-0.5 text-xs text-base-content/60">${quantityLabel(item.quantity)}</p>
              <div class="mt-2 flex items-center justify-between gap-3">
                <div class="font-bold tabular-nums">
                  ${onSale ? `<s class="mr-1.5 text-sm font-normal text-base-content/40">${formatMoney(item.original_line_price)}</s>` : ''}
                  ${formatMoney(item.final_line_price)}
                </div>
                <button type="button" class="border-0 bg-transparent p-0 text-xs font-medium text-base-content/60 hover:text-base-content" data-cart-remove data-line-key="${item.key}">
                  ${i18n.remove || 'Remove'}
                </button>
              </div>
            </div>
          </article>
        </li>
      `;
    }

    function getCookieDomain() {
      return location.hostname.endsWith('label-source.co.uk')
        ? '; domain=.label-source.co.uk'
        : '';
    }

    function syncCartCountCookie(count) {
      const COOKIE_MAX_AGE = 86400;
      const base = `ls_cart_count=${count}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax${getCookieDomain()}`;
      document.cookie = location.protocol === 'https:' ? `${base}; Secure` : base;
    }

    function updateBadges(count) {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        if (badge.closest('[data-cart-ui]')) return;
        badge.textContent = count;
        badge.hidden = count === 0;
      });
      syncCartCountCookie(count);
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { item_count: count } }));
    }

    function setEmpty(els, isEmpty) {
      els.empty?.classList.toggle('hidden', !isEmpty);
      if (els.body) {
        els.body.classList.toggle('hidden', isEmpty);
      } else {
        els.items?.classList.toggle('hidden', isEmpty);
      }
      els.footer?.classList.toggle('hidden', isEmpty);
      els.stickyCheckout?.classList.toggle('hidden', isEmpty);
      els.count?.classList.toggle('hidden', isEmpty);
    }

    function renderCartItemsFromHTML(html) {
      cartRoots.forEach((root) => {
        const itemsEl = root.querySelector('[data-cart-items]');
        if (itemsEl) itemsEl.innerHTML = html || '';
      });
    }

    function updateAllRoots(cart, itemsHTML) {
      const isEmpty = !cart.items || cart.items.length === 0;
      const totalFormatted = formatMoney(cart.total_price);

      cartRoots.forEach((root) => {
        const els = getRootEls(root);
        if (els.items && itemsHTML !== undefined) {
          els.items.innerHTML = isEmpty ? '' : itemsHTML;
        }
        els.checkouts?.forEach((checkout) => {
          checkout.textContent = checkoutLabel(totalFormatted);
        });
        if (els.count) els.count.textContent = itemCountLabel(cart.item_count);
        setEmpty(els, isEmpty);
      });

      updateBadges(cart.item_count);
    }

    async function fetchCartItemsHTML() {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}?sections=cart-items`);
      if (!response.ok) throw new Error('Failed to fetch cart items');

      const sections = await response.json();
      return sections['cart-items'] || '';
    }

    async function renderCartItems(cart) {
      const isEmpty = !cart.items || cart.items.length === 0;
      if (isEmpty) {
        renderCartItemsFromHTML('');
        return;
      }

      const html = await fetchCartItemsHTML();
      renderCartItemsFromHTML(html);
    }

    async function renderCart(cart) {
      const isEmpty = !cart.items || cart.items.length === 0;

      try {
        await renderCartItems(cart);
        updateAllRoots(cart);
      } catch {
        const fallbackHTML = isEmpty
          ? ''
          : `<div class="overflow-hidden rounded-2xl border border-white/55 bg-white/35"><ul class="m-0 list-none p-0 divide-y divide-white/55" role="list">${cart.items.map(renderItem).join('')}</ul></div>`;
        updateAllRoots(cart, fallbackHTML);
      }
    }

    async function fetchCart() {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to fetch cart');
      return response.json();
    }

    const CartDrawer = {
      open() {
        toggle.checked = true;
        if (!isCartOperation) {
          this.refresh();
        }
      },

      close() {
        toggle.checked = false;
      },

      async refresh() {
        const cart = await fetchCart();
        await renderCart(cart);
        return cart;
      },

      async add(variantId, quantity = 1) {
        return new Promise((resolve, reject) => {
          cartOperationQueue = cartOperationQueue.then(async () => {
            try {
              isCartOperation = true;
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  items: [{ id: Number(variantId), quantity: Number(quantity) }],
                  sections: 'cart-items',
                  sections_url: window.location.pathname
                }),
              });

              if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                const description = error.description || error.message || 'Failed to add to basket';
                const err = new Error(description);

                if (response.status === 422) {
                  if (/maximum quantity|already in your cart/i.test(description)) {
                    err.code = 'ALREADY_IN_CART';
                  } else if (/inventory|stock|available/i.test(description)) {
                    err.code = 'OUT_OF_STOCK';
                  } else if (/not found|does not exist/i.test(description)) {
                    err.code = 'PRODUCT_NOT_FOUND';
                  }
                }

                throw err;
              }

              const data = await response.json();

              if (data.sections && data.sections['cart-items']) {
                renderCartItemsFromHTML(data.sections['cart-items']);
              }

              const cart = await fetchCart();
              updateAllRoots(cart);
              isCartOperation = false;
              resolve(cart);
            } catch (err) {
              isCartOperation = false;
              reject(err);
            }
          });
        });
      },

      hideCartToast() {
        if (!cartChangeToast) return;
        clearTimeout(cartToastTimeout);
        cartChangeToast.classList.add('hidden');
        Object.values(toastPanels).forEach((panel) => panel?.classList.add('hidden'));
      },

      showCartToast(type, message) {
        if (!cartChangeToast) return;

        this.hideCartToast();

        let panel = toastPanels[type];

        if (!panel) {
          panel = toastPanels.error;
        }

        if (!panel) return;

        if ((type === 'error' || type === 'OUT_OF_STOCK' || type === 'PRODUCT_NOT_FOUND') && toastErrorMessage) {
          toastErrorMessage.textContent = message || i18n.addError || 'Could not add to bag';
        }

        panel.classList.remove('hidden');
        cartChangeToast.classList.remove('hidden');

        if (type === 'success') {
          document.querySelectorAll('.navbar [data-cart-drawer-open]').forEach((btn) => {
            btn.classList.remove('cart-wiggle-once');
            void btn.offsetWidth;
            btn.classList.add('cart-wiggle-once');
            btn.addEventListener(
              'animationend',
              () => btn.classList.remove('cart-wiggle-once'),
              { once: true }
            );
          });
        }

        cartToastTimeout = setTimeout(() => this.hideCartToast(), 4000);
      },

      async remove(lineKey) {
        return new Promise((resolve, reject) => {
          cartOperationQueue = cartOperationQueue.then(async () => {
            try {
              isCartOperation = true;
              const lineItems = document.querySelectorAll(`[data-cart-line-key="${lineKey}"]`);
              const lineItem = lineItems[0];

              if (lineItem) {
                const itemData = {
                  item_id: lineItem.dataset.itemId || '',
                  item_name: lineItem.dataset.itemName || '',
                  item_brand: lineItem.dataset.itemBrand || '',
                  item_category: lineItem.dataset.itemCategory || '',
                  price: parseFloat(lineItem.dataset.itemPrice || '0'),
                  quantity: 1
                };

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'remove_from_cart',
                  ecommerce: {
                    currency: currency,
                    value: itemData.price,
                    items: [itemData]
                  }
                });
              }

              lineItems.forEach((el) => el.classList.add('removing'));
              if (lineItems.length > 0) {
                await new Promise((resolve) => setTimeout(resolve, 300));
              }

              const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: lineKey,
                  quantity: 0,
                  sections: 'cart-items',
                  sections_url: window.location.pathname
                }),
              });

              if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                throw new Error(error.description || error.message || 'Failed to remove item');
              }

              const data = await response.json();

              if (data.sections && data.sections['cart-items']) {
                renderCartItemsFromHTML(data.sections['cart-items']);
              }

              updateAllRoots(data);
              isCartOperation = false;
              resolve(data);
            } catch (err) {
              isCartOperation = false;
              reject(err);
            }
          });
        });
      },
    };

    window.CartDrawer = CartDrawer;

    const originalOpen = CartDrawer.open.bind(CartDrawer);
    CartDrawer.open = function () {
      CartDrawer.hideCartToast();
      originalOpen();
    };

    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-cart-drawer-open]');
      if (openBtn) {
        event.preventDefault();
        CartDrawer.open();
        return;
      }

      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn && removeBtn.closest('[data-cart-ui]')) {
        event.preventDefault();
        CartDrawer.remove(removeBtn.dataset.lineKey);
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form.product-sticky-cart__form');
      if (!form) return;

      const addBtn = form.querySelector('[name="add"]');
      if (!addBtn || addBtn.disabled) return;

      event.preventDefault();

      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      addBtn.disabled = true;
      try {
        await CartDrawer.add(variantInput.value, 1);
        CartDrawer.showCartToast('success');
      } catch (error) {
        if (error.code === 'ALREADY_IN_CART') {
          CartDrawer.showCartToast('already_in_bag');
          return;
        }
        if (error.code === 'OUT_OF_STOCK') {
          CartDrawer.showCartToast('error', error.message || 'This item is no longer available');
          return;
        }
        if (error.code === 'PRODUCT_NOT_FOUND') {
          CartDrawer.showCartToast('error', error.message || 'Product not found');
          return;
        }
        CartDrawer.showCartToast('error', error.message);
      } finally {
        addBtn.disabled = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-bar-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const scrollEl = document.querySelector('[data-filter-bar-scroll]');
    if (!scrollEl) return;

    function updateScrollFade() {
      const { scrollLeft, scrollWidth, clientWidth } = scrollEl;
      const canScroll = scrollWidth > clientWidth + 2;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
      const atStart = scrollLeft <= 2;
      scrollEl.classList.toggle('is-scrollable', canScroll);
      scrollEl.classList.toggle('is-at-end', atEnd);
      scrollEl.classList.toggle('is-at-start', atStart);
    }

    scrollEl.addEventListener('scroll', updateScrollFade, { passive: true });
    window.addEventListener('resize', updateScrollFade);
    new MutationObserver(updateScrollFade).observe(scrollEl, { childList: true, subtree: true });
    updateScrollFade();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters-menu-sheet-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const menuSheet = document.querySelector('[data-filters-menu-dock]');
    if (!menuSheet) return;

    const pillsScroll = menuSheet.querySelector('[data-filters-menu-pills-scroll]');
    const pillsContainer = menuSheet.querySelector('[data-filters-menu-pills]');
    const activeSection = menuSheet.querySelector('[data-filters-menu-active]');

    function updatePillsScrollFade() {
      if (!pillsScroll) return;
      const { scrollLeft, scrollWidth, clientWidth } = pillsScroll;
      const canScroll = scrollWidth > clientWidth + 2;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
      pillsScroll.classList.toggle('is-scrollable', canScroll);
      pillsScroll.classList.toggle('is-at-end', atEnd);
    }

    if (pillsScroll && pillsContainer) {
      pillsScroll.addEventListener('scroll', updatePillsScrollFade, { passive: true });
      window.addEventListener('resize', updatePillsScrollFade);
      new MutationObserver(updatePillsScrollFade).observe(pillsContainer, { childList: true, subtree: true });
      if (activeSection) {
        new MutationObserver(function() {
          requestAnimationFrame(updatePillsScrollFade);
        }).observe(activeSection, { attributes: true, attributeFilter: ['class'] });
      }
      updatePillsScrollFade();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-desktop"] && !Shopify.designMode) return;
  try {
    (function () {
    const nav = document.querySelector('[data-header-nav]');
    if (nav) {
      nav.addEventListener('click', (event) => {
        const link = event.target.closest('[data-header-nav-link]');
        if (link && document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      });
    }

    function updateFavouritesBadges() {
      const badges = document.querySelectorAll('[data-favourites-count]');
      if (badges.length === 0) return;

      if (!window.Favourites) {
        setTimeout(updateFavouritesBadges, 100);
        return;
      }

      const count = window.Favourites.count();
      badges.forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateFavouritesBadges);
    } else {
      updateFavouritesBadges();
    }

    document.addEventListener('favourites:change', updateFavouritesBadges);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-product-mobile"] && !Shopify.designMode) return;
  try {
    (function() {
    const header = document.querySelector('[data-product-header]');
    const backBtn = document.querySelector('[data-product-back-btn]');
    
    if (!header || !backBtn) return;

    // Back button navigation — hard reload via stored return URL
    backBtn.addEventListener('click', () => {
      window.LSNavigationMemory?.navigateBack('/');
    });

    // Reveal header metadata when price scrolls under the fixed header bar
    const priceSentinel = document.getElementById('product-price-sentinel');
    if (!priceSentinel || !window.matchMedia('(max-width: 767px)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const headerHeight = header.offsetHeight;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          header.classList.toggle('is-scrolled', !entry.isIntersecting);
        });
      },
      { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0 }
    );
    observer.observe(priceSentinel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const drawerToggle = document.getElementById('header-nav-drawer');
    const navRoot = document.querySelector('[data-mobile-nav]');
    if (!drawerToggle || !navRoot) return;

    const panels = navRoot.querySelectorAll('[data-nav-panel]');
    let panelStack = ['root'];

    function showPanel(id) {
      panels.forEach(function (panel) {
        if (panel.dataset.navPanel === id) {
          panel.classList.remove('translate-x-full');
          panel.classList.add('translate-x-0');
        } else {
          panel.classList.remove('translate-x-0');
          panel.classList.add('translate-x-full');
        }
      });
    }

    function resetPanels() {
      panelStack = ['root'];
      showPanel('root');
    }

    navRoot.addEventListener('click', function (event) {
      const targetBtn = event.target.closest('[data-nav-target]');
      if (targetBtn) {
        event.preventDefault();
        const targetId = targetBtn.dataset.navTarget;
        panelStack.push(targetId);
        showPanel(targetId);
        return;
      }

      const backBtn = event.target.closest('[data-nav-back]');
      if (backBtn) {
        event.preventDefault();
        if (panelStack.length > 1) {
          panelStack.pop();
          showPanel(panelStack[panelStack.length - 1]);
        }
        return;
      }

      const link = event.target.closest('a[href]');
      if (link && navRoot.contains(link)) {
        drawerToggle.checked = false;
        resetPanels();
      }
    });

    drawerToggle.addEventListener('change', function () {
      if (!drawerToggle.checked) {
        resetPanels();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sell-sticky-footer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sellStickyFooterInit) return;
    window.__sellStickyFooterInit = true;

    var footer = document.querySelector('[data-sell-sticky-footer]');
    if (!footer) return;

    var heroSelector = footer.getAttribute('data-hero-cta-selector') || '[data-hero-cta]';
    var heroCta = document.querySelector(heroSelector);

    if (!footer || !heroCta) {
      if (footer) footer.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      footer.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          footer.classList.toggle('is-visible', !entry.isIntersecting);
          window.LSStickyBottomInset?.update();
        });
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );

    observer.observe(heroCta);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal-content"] && !Shopify.designMode) return;
  try {
    (function () {
    var SCROLL_THRESHOLD = 8;
    var sizeGuideDataPromise = null;

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatCell(value) {
      if (value === null || value === undefined || String(value).trim() === '') return '—';
      return value;
    }

    function isNaValue(value) {
      return String(value).trim().toUpperCase() === 'N/A';
    }

    function getVisibleColumns(columns, rows) {
      if (!rows || !rows.length) return columns;
      var firstRow = rows[0];
      return columns.filter(function (column) {
        return !isNaValue(firstRow[column.key]);
      });
    }

    function loadSizeGuideData(url) {
      if (!url) return Promise.reject(new Error('Missing size guide data URL'));
      if (!sizeGuideDataPromise) {
        sizeGuideDataPromise = fetch(url).then(function (response) {
          if (!response.ok) throw new Error('Failed to load size guide data');
          return response.json();
        });
      }
      return sizeGuideDataPromise;
    }

    function renderSizeGuideTable(table, columns, rows) {
      if (!table || !columns || !columns.length) return;

      var visibleColumns = getVisibleColumns(columns, rows);
      if (!visibleColumns.length) {
        table.innerHTML = '<tbody><tr><td class="text-xs text-black/45 px-3 py-4">No sizes available.</td></tr></tbody>';
        return;
      }

      var thead = '<thead><tr class="bg-base-200">';
      visibleColumns.forEach(function (column, index) {
        var stickyClass = index === 0 ? ' sticky left-0 z-10 bg-base-200' : '';
        thead += '<th scope="col" class="text-left text-xs font-bold uppercase text-black/60 px-3 py-2 whitespace-nowrap' + stickyClass + '">' +
          escapeHtml(column.label) + '</th>';
      });
      thead += '</tr></thead>';

      var tbody = '<tbody>';
      if (!rows || !rows.length) {
        tbody += '<tr><td colspan="' + visibleColumns.length + '" class="text-xs text-black/45 px-3 py-4">No sizes available.</td></tr>';
      } else {
        rows.forEach(function (row) {
          tbody += '<tr class="border-b border-base-200">';
          visibleColumns.forEach(function (column, index) {
            var value = formatCell(row[column.key]);
            if (index === 0) {
              tbody += '<th scope="row" class="text-left font-semibold text-black text-xs sticky left-0 bg-white z-10 px-3 py-2 whitespace-nowrap">' +
                escapeHtml(value) + '</th>';
            } else {
              tbody += '<td class="text-left text-xs text-black/80 whitespace-nowrap px-3 py-2">' +
                escapeHtml(value) + '</td>';
            }
          });
          tbody += '</tr>';
        });
      }
      tbody += '</tbody>';

      table.innerHTML = thead + tbody;
    }

    function renderSizeGuideTables(root, data) {
      if (!root || !data) return;

      root.querySelectorAll('[data-size-guide-panel]').forEach(function (panel) {
        var panelKey = panel.getAttribute('data-size-guide-panel');
        var parts = panelKey ? panelKey.split('-') : [];
        var genderId = parts[0];
        var tabId = parts.slice(1).join('-');
        var group = data.groups && data.groups[genderId] && data.groups[genderId][tabId];
        var table = panel.querySelector('.size-guide-modal__table');
        renderSizeGuideTable(table, data.columns, group ? group.rows : []);
      });
    }

    function getSizeGuideRoot(node) {
      return node && node.closest ? node.closest('.size-guide-modal') : null;
    }

    function syncSizeGuidePanels(root) {
      if (!root) return;
      var genderId = root.getAttribute('data-active-gender') || 'mens';
      var tabId = root.getAttribute('data-active-tab') || 'tops';
      var modalId = root.getAttribute('data-modal-id');

      root.querySelectorAll('.size-guide-modal__panel').forEach(function (panel) {
        var isActive = panel.id === modalId + '-panel-' + genderId + '-' + tabId;
        panel.classList.toggle('hidden', !isActive);
        panel.hidden = !isActive;
      });
    }

    function resetSizeGuideScroll(root) {
      if (!root) return;
      root.querySelectorAll('.size-guide-modal__table-wrap').forEach(function (el) {
        el.scrollLeft = 0;
        el.scrollTop = 0;
      });
    }

    function syncHorizontalScrollAffordance(root) {
      if (!root) return;
      root.querySelectorAll('.size-guide-modal__table-scroll').forEach(function (wrap) {
        var scroll = wrap.querySelector('.size-guide-modal__table-wrap');
        if (!scroll) return;

        var canScrollX = scroll.scrollWidth > scroll.clientWidth + 1;
        var atLeft = scroll.scrollLeft <= SCROLL_THRESHOLD;
        var atRight = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - SCROLL_THRESHOLD;

        wrap.classList.toggle('has-more-left', canScrollX && !atLeft);
        wrap.classList.toggle('has-more-right', canScrollX && !atRight);
      });
    }

    function bindScrollAffordance(root) {
      if (!root || root.dataset.scrollBound === 'true') return;
      root.dataset.scrollBound = 'true';

      root.querySelectorAll('.size-guide-modal__table-wrap').forEach(function (scroll) {
        scroll.addEventListener('scroll', function () {
          syncHorizontalScrollAffordance(root);
        }, { passive: true });

        if (window.ResizeObserver) {
          var resizeObserver = new ResizeObserver(function () {
            syncHorizontalScrollAffordance(root);
          });
          resizeObserver.observe(scroll);
        }
      });
    }

    function switchSizeGuideGender(root, genderId) {
      if (!root || !genderId) return;
      root.setAttribute('data-active-gender', genderId);
      root.querySelectorAll('[data-size-guide-gender]').forEach(function (btn) {
        var isActive = btn.getAttribute('data-size-guide-gender') === genderId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      syncSizeGuidePanels(root);
      resetSizeGuideScroll(root);
      syncHorizontalScrollAffordance(root);
    }

    function switchSizeGuideTab(root, tabId) {
      if (!root || !tabId) return;
      root.setAttribute('data-active-tab', tabId);
      root.querySelectorAll('[data-size-guide-tab]').forEach(function (btn) {
        var isActive = btn.getAttribute('data-size-guide-tab') === tabId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      syncSizeGuidePanels(root);
      resetSizeGuideScroll(root);
      syncHorizontalScrollAffordance(root);
    }

    function resetSizeGuide(root) {
      if (!root) return;
      switchSizeGuideGender(root, 'mens');
      switchSizeGuideTab(root, 'tops');
    }

    function initSizeGuideDialog(dialog) {
      if (!dialog) return;
      var root = dialog.querySelector('.size-guide-modal');
      if (!root) return;

      bindScrollAffordance(root);
      resetSizeGuide(root);

      loadSizeGuideData(root.getAttribute('data-size-guide-url'))
        .then(function (data) {
          renderSizeGuideTables(root, data);
          window.requestAnimationFrame(function () {
            syncHorizontalScrollAffordance(root);
          });
        })
        .catch(function () {
          root.querySelectorAll('.size-guide-modal__table').forEach(function (table) {
            table.innerHTML = '<tbody><tr><td class="text-xs text-black/45 px-3 py-4">Unable to load size guide.</td></tr></tbody>';
          });
        });
    }

    document.addEventListener('click', function (event) {
      var genderTrigger = event.target.closest('[data-size-guide-gender]');
      if (genderTrigger) {
        switchSizeGuideGender(getSizeGuideRoot(genderTrigger), genderTrigger.getAttribute('data-size-guide-gender'));
        return;
      }

      var tabTrigger = event.target.closest('[data-size-guide-tab]');
      if (tabTrigger) {
        switchSizeGuideTab(getSizeGuideRoot(tabTrigger), tabTrigger.getAttribute('data-size-guide-tab'));
        return;
      }

      var modalTrigger = event.target.closest('.modal-trigger[data-modal^="size-modal-"]');
      if (modalTrigger) {
        var dialog = document.getElementById(modalTrigger.getAttribute('data-modal'));
        window.requestAnimationFrame(function () {
          initSizeGuideDialog(dialog);
        });
      }
    });

    document.querySelectorAll('dialog.info-modal').forEach(function (dialog) {
      if (!dialog.id || dialog.id.indexOf('size-modal-') !== 0) return;
      dialog.addEventListener('close', function () {
        var root = dialog.querySelector('.size-guide-modal');
        if (root) resetSizeGuide(root);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-bottom-shared"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__stickyBottomInsetInit) return;
    window.__stickyBottomInsetInit = true;

    var mobileQuery = window.matchMedia('(max-width: 1023px)');
    var observers = [];

    function isStickyVisible(el) {
      if (!el || el.classList.contains('hidden') || el.hasAttribute('hidden')) return false;
      if (window.getComputedStyle(el).display === 'none') return false;
      if (el.classList.contains('sell-quote-footer') && !el.classList.contains('is-visible')) return false;
      return el.getBoundingClientRect().height > 0;
    }

    function getActiveSticky() {
      var nodes = document.querySelectorAll('.sticky-bottom-wrapper');
      var i;
      var el;

      for (i = 0; i < nodes.length; i++) {
        el = nodes[i];
        if (el.classList.contains('bottom-nav')) continue;
        if (isStickyVisible(el)) return el;
      }

      for (i = 0; i < nodes.length; i++) {
        el = nodes[i];
        if (isStickyVisible(el)) return el;
      }

      return null;
    }

    function updateLayoutBottomInset() {
      if (!mobileQuery.matches) {
        document.documentElement.style.setProperty('--layout-bottom-inset', '0px');
        return;
      }

      var sticky = getActiveSticky();
      if (!sticky) {
        document.documentElement.style.setProperty('--layout-bottom-inset', '0px');
        return;
      }

      document.documentElement.style.setProperty(
        '--layout-bottom-inset',
        sticky.getBoundingClientRect().height + 'px'
      );
    }

    function bindObservers() {
      observers.forEach(function (observer) {
        observer.disconnect();
      });
      observers = [];

      if (typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(updateLayoutBottomInset);
        document.querySelectorAll('.sticky-bottom-wrapper').forEach(function (el) {
          resizeObserver.observe(el);
        });
        observers.push(resizeObserver);
      }

      document.querySelectorAll('[data-sell-sticky-footer], [data-cart-sticky-checkout]').forEach(function (el) {
        var mutationObserver = new MutationObserver(updateLayoutBottomInset);
        mutationObserver.observe(el, { attributes: true, attributeFilter: ['class', 'hidden'] });
        observers.push(mutationObserver);
      });
    }

    function init() {
      bindObservers();
      updateLayoutBottomInset();
      mobileQuery.addEventListener('change', updateLayoutBottomInset);
      window.addEventListener('orientationchange', updateLayoutBottomInset);
    }

    window.LSStickyBottomInset = { update: updateLayoutBottomInset };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
